import "reflect-metadata";
import { lazy } from "react";
import { injectable, registry } from "tsyringe";
import { FeatureSetupDef, FeatureRootRoute, FeatureSetup } from "@app/types/feature.types";

import { version, name } from "@feature/package.json";
import { FeatureToken } from "@app/constants/di";
import { featurePaths } from "@feature/constants/paths.constant";

const ExhibitorListPage = lazy(() => import("@feature/pages/ExhibitorList"));
const CreateExhibitorPage = lazy(() => import("@feature/pages/CreateExhibitor"));
const EditExhibitorPage = lazy(() => import("@feature/pages/EditExhibitor"));

@injectable()
@registry([{ token: FeatureToken, useClass: ExhibitorManagement }])
class ExhibitorManagement implements FeatureSetupDef {
    GetFeatureSetup(): FeatureSetup {
        return {
            version,
            namespace: name,
            featuresRoot: this.features,
            permissions: [],
            index: true        };
    }
    
    private readonly features: FeatureRootRoute = {
        requiredPermissions: [],
        children: [
            {
                title: "Exhibitor List",
                path: featurePaths.exhibitorList,
                page: ExhibitorListPage
            },
            {
                title: "Create Exhibitor",
                path: featurePaths.createExhibitor,
                page: CreateExhibitorPage
            },
            {
                title: "Edit Exhibitor",
                path: featurePaths.editExhibitor,
                page: EditExhibitorPage
            },
        ]
    };
}

export default ExhibitorManagement;
